import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation } from 'swiper/core';
import { applicationActions } from 'store/application';
SwiperCore.use([Navigation]);
var Container = styled.div.withConfig({
  displayName: "SelectedServiceSlider__Container",
  componentId: "sc-1v6pnmd-0"
})([".mySwiper{--swiper-theme-color:black !important;--swiper-navigation-size:15px;position:relative;padding:0 30px;margin-top:30px;.swiper-wrapper{display:flex;-ms-overflow-style:none;&::-webkit-scrollbar{display:none;}.swiper-slide{display:flex;flex-wrap:wrap;min-width:100%;span{min-width:33.3%;width:33.3%;margin-top:14px;padding:0 3px;box-sizing:border-box;label{overflow:hidden;display:flex;justify-content:center;align-items:center;height:42px;padding:2px 7px 0;border:1px solid #111;border-radius:30px;font-size:13px;text-align:center;&:before,&:after{display:none;}}input[type='checkbox']:checked + label{background:#111;color:#fff;font-weight:bold;}}}}.swiper-button-prev{top:50% !important;}.swiper-button-next{top:50% !important;}}"]);

var SelectedServiceSlider = function SelectedServiceSlider() {
  var dispatch = useDispatch();

  var onChangeCheck = function onChangeCheck(event) {
    var check = event.target.checked;
    var value = event.target.value;

    if (check) {
      dispatch(applicationActions.setSelectedService(value));
    } else {
      dispatch(applicationActions.removeSelectedService(value));
    }
  };

  return /*#__PURE__*/_jsx(Container, {
    children: /*#__PURE__*/_jsxs(Swiper, {
      navigation: true,
      spaceBetween: 30,
      className: "mySwiper",
      children: [/*#__PURE__*/_jsxs(SwiperSlide, {
        children: [/*#__PURE__*/_jsxs("span", {
          children: [/*#__PURE__*/_jsx("input", {
            type: "checkbox",
            id: "MEMBERSHIP",
            onChange: onChangeCheck,
            value: "MEMBERSHIP"
          }), /*#__PURE__*/_jsx("label", {
            htmlFor: "MEMBERSHIP",
            children: "\uBA64\uBC84\uC2ED"
          })]
        }), /*#__PURE__*/_jsxs("span", {
          children: [/*#__PURE__*/_jsx("input", {
            type: "checkbox",
            id: "LIVING_STUDIO",
            onChange: onChangeCheck,
            value: "LIVING_STUDIO"
          }), /*#__PURE__*/_jsx("label", {
            htmlFor: "LIVING_STUDIO",
            children: "*1\uC778 \uC8FC\uAC70"
          })]
        }), /*#__PURE__*/_jsxs("span", {
          children: [/*#__PURE__*/_jsx("input", {
            type: "checkbox",
            id: "OFFICE",
            onChange: onChangeCheck,
            value: "OFFICE"
          }), /*#__PURE__*/_jsx("label", {
            htmlFor: "OFFICE",
            children: "\uC624\uD53C\uC2A4"
          })]
        })]
      }), /*#__PURE__*/_jsx(SwiperSlide, {
        children: /*#__PURE__*/_jsxs("span", {
          children: [/*#__PURE__*/_jsx("input", {
            type: "checkbox",
            id: "SEAT",
            onChange: onChangeCheck,
            value: "SEAT"
          }), /*#__PURE__*/_jsx("label", {
            htmlFor: "SEAT",
            children: "1\uC778 \uB370\uC2A4\uD06C"
          })]
        })
      })]
    })
  });
};

export default SelectedServiceSlider;